import { Injectable } from '@angular/core';

import { Query, gql } from 'apollo-angular';

import { QuerySearchAutoSuggestionsArgs, SearchAutoSuggestions } from '@hdms/shared/common-types';

export interface SearchSuggestResponse {
  searchAutoSuggestions: SearchAutoSuggestions;
}

@Injectable({
  providedIn: 'root'
})
export class HeaderAutoSuggestGqlService extends Query<SearchSuggestResponse, QuerySearchAutoSuggestionsArgs> {
  override document = gql`
    query HeaderSearchAutoSuggestions($filter: SearchAutoSuggestionsFilterInput!) {
      searchAutoSuggestions(filter: $filter) {
        categories {
          id
          title
          parent {
            id
            title
          }
        }
        products {
          id
          thumbnail
          title
          isNuron
          isNew
          isSpecial
        }
      }
    }
  `;
}
